import { Directive, effect, inject, input } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { isNil, Nillable } from '@web/utils';

@Directive({
  selector: '[appPrimengDialogCustomCloseEvent]',
  standalone: true,
})
export class PrimengDialogCustomCloseEventDirective {
  public readonly customCloseEvent = input<Nillable<(event?: Event) => void>>();

  private readonly dialog = inject(Dialog);
  private readonly originalCloseEvent: (event: Event) => void;

  public constructor() {
    this.originalCloseEvent = this.prepareOriginalCloseEvent();

    effect(() => this.configureCustomCloseEvent());
  }

  private configureCustomCloseEvent(): void {
    const customCloseEvent = this.customCloseEvent();

    if (isNil(customCloseEvent)) {
      this.dialog.close = this.originalCloseEvent;

      return;
    }

    this.dialog.close = (event: Event) => {
      this.originalCloseEvent(event);
      customCloseEvent(event);
    };
  }

  private prepareOriginalCloseEvent(): (event: Event) => void {
    return this.dialog.close.bind(this.dialog);
  }
}
